<template>
  <div>
    <!-- Pump Status Store -->
  </div>
</template>

<script>
export default {
  name: 'PumpStatusStore',
  props: {
    location:{default: 'RCGB', type:String},
    isPayAtPump:{default: false, type:Boolean},
    refresh: {default: 10000,type: Number}
  },
  data () { return { 
      data: [],
      dataIsUpdating: false,
      diskSpace: [],
      interval: undefined,
    } 
  },
  async created () {
    this.updateData()
  },
  //210127 Does the interval do anything?
  mounted() {
    this.interval = setInterval(this.updateData, this.refresh);
    window.addEventListener('focus', this.updateData);
  },
  //210127 Does the interval do anything?
  destroyed() {
    clearInterval(this.interval);
    window.removeEventListener('focus', this.updateData);
  },
  methods:{
    updateData: function(){
      if (!document.hasFocus() && this.data.length > 0)
        return;
      this.updateLocationData()
    },
    updateLocationData: function(){
      this.dataIsUpdating = true
      this.$axios.post('/LiveData/pumpStatus', {location:this.location, isPayAtPump:this.isPayAtPump}).then((r)=>{
        this.data = r.data.map(r=>({...r, ts: r.date }))
        this.dataIsUpdating = false
      })
      // 210127 temporarily removed the DBSpace
      // if (this.isPayAtPump)
      //   return;
      // this.$axios.post('/getDBSpace', {location:this.location}).then((r)=>this.diskSpace = r.data)
    },
  },
}
</script>

<style>

</style>
